import { useSelector } from "react-redux";
import { FormattedMessage } from 'react-intl';
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { useNavigate } from "react-router-dom";
import { selectCurrent } from "../../../../../../redux/settings/selectors";
import { selectFulfillmentProvidersListItems } from "../../../../../../redux/fulfillment-providers/selector";
import PageLoader from "../../../../../../components/PageLoader";
import Table from "../../../../../../common/components/table";
import { fulfillmentProviders } from "../../../../../../redux/fulfillment-providers/action";

const ManagementFulfillmentProviders = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
	const result = useSelector(selectCurrent)
	const { header, footer, currency } = result
    const fulfillmentProviderItems = useSelector(selectFulfillmentProvidersListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'Name', headerName: 'Name' },
      { field: 'PhoneNumber', headerName: 'Phone Number' },
      { field: 'AccountName', headerName: 'Account Name' },
      { field: 'DisplayOrder', headerName: 'Display Order' },
      { field: 'IsInternalProvider', headerName: 'Internal Provider', cellRenderer: 'yesNoRenderer' },
      { field: 'IsActive', headerName: 'Active', cellRenderer: 'yesNoRenderer' },
      { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
      { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true }
      
        ]);
      }
      const fetchFulfillmentProviders =()=>{

        dispatch(fulfillmentProviders.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/fullfillment/fulfillment-providers/list`,entity:'fulfillmentProviders',jsonData:{
          "PageNumber": pageData,
             "PageSize": 10,
             "SortField": "Id",
             "SortOrder": "desc",}
         }));
       
      }
	useEffect(() => {
        createColumnDefs()
        fetchFulfillmentProviders()
	}, [pageData])

  const handleAdd=()=>{
    navigate(`${0}`)
  }
  const handleEdit=(data: any)=>{
    navigate(`${data?.Id}`)
  }

  const additionButtons: any = [
    {
      name: 'Add FulfillmentProvider',
      callback: () => handleAdd(),
    }
  ];
  const handleDelete=(data: any)=>{
    dispatch(fulfillmentProviders.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/fullfillment/fulfillment-providers/delete`,
      entity: 'fulfillmentProviders',
      jsonData: {
          Records: [
              {
                  Id: data?.Id
              }
          ]
      }
  })).then(() => {
    dispatch(fulfillmentProviders.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/fullfillment/fulfillment-providers/list`,entity:'fulfillmentProviders',jsonData:{
          "PageNumber": pageData,
             "PageSize": 10,
             "SortField": "Id",
             "SortOrder": "desc",}
         }));
  });
  } 
	return (
    <>
    {fulfillmentProviderItems?.isLoading ? 
    <PageLoader />
:   
		<Table columnData={columnDefs} rowData={fulfillmentProviderItems?.result?.items} setPageData={setPageData}
    paginationData={fulfillmentProviderItems?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons} headingName="Fulfillment Provider" />
  }
  </> 
     
	);
};

export default ManagementFulfillmentProviders;


